import React, { Component } from "react";
import { toast } from "react-toastify";
import _ from "lodash";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import FileSaver from "file-saver";
import Moment from "moment";

import PromptModal from "components/Indicator/Prompt";

import { Get } from "utils/axios";

import getDomainURL from "utils/api";

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      sstReports: [],
    };

    load = (param) => this.setState({ loading: param });
    requestError = (error) => toast.error(error);
    requestSuccess = (success) => toast.success(success);

    onChangeSSTReportHOC = (key, val) => this.setState({ [key]: val });

    exportSSTReport = (data) => {
      let headers = new Headers();
      headers.append(
        "Authorization",
        `Bearer ${Cookies.get("PRIMEVIEW_WEB_TOKEN")}`
      );
      this.load(true);
      fetch(
        `${getDomainURL()}/reports/download_sst_report?company_id=${
          data.company_id
        }&start_date=${data.start_date}&end_date=${data.end_date}`,
        {
          headers: headers,
        }
      )
        .then((res) => res.blob())
        .then((blobby) => {
          this.load(false);
          return FileSaver.saveAs(
            blobby,
            `${Moment().format("YYYYMMDDHH:mm")}_sst_report.pdf`
          );
        })
        .catch((error) => {
          this.load(false);
          this.requestError("Failed to save SST report. Please try again.");
        });
    };

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          onLoadSSTReport={this.state.loading}
          exportSSTReport={this.exportSSTReport}
        />
      );
    };
  }
  return WithHOC;
};

export default HOC;
